import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import AttributeValueForm from "../../../Components/Forms/Pages/Product/AttributeValueForm";
import DrawerContext from "../../../Context/DrawerContext";
import { addAttributeValue } from "../../../Services/Product/AttributeValueService";
import LinearProgress from '@mui/material/LinearProgress';
import SnackbarContext from "../../../Context/SnackbarContext";


const formRules = {
    'name': {required: true}
}

const AddAttributeValue = (props) => {

    const siteData = useSelector((state) => state.siteData)
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, control, watch, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);



    useEffect(() => {
        setDrawerTitle(strings.pages.product.attributeValue.addAttributeValue);
    });


    const onSubmit = (data) => {

        setShowLoader(true);

        const requestData = { attributeId: props.attributeId, ...data}

        addAttributeValue(requestData).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish(response.data.entity);
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <AttributeValueForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                errors={errors} data={data} form={form} control={control}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}
                watch={watch}/>
        </Paper>
    </div>
}

export default AddAttributeValue;